import { ShieldCheck, Flag, ClipboardCheck, Banknote, Award, ThumbsUp } from "lucide-react";

const items = [
  { Icon: Flag, label: "Veteran-owned & operated" },
  { Icon: Banknote, label: "Same-day payment" },
  { Icon: Award, label: "25+ years in the business" },
  { Icon: ThumbsUp, label: "Satisfaction guaranteed" },
  { Icon: ClipboardCheck, label: "Written offer after inspection" },
  { Icon: ShieldCheck, label: "No-obligation offer request" },
];

export default function TrustBadges({ tone = "light" }) {
  return (
    <div
      data-testid="trust-badges"
      className={`grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 sm:gap-4`}
    >
      {items.map(({ Icon, label }) => (
        <div
          key={label}
          className={`flex items-center gap-3 rounded-xl px-4 py-3 border ${
            tone === "dark"
              ? "border-white/15 bg-white/5 text-slate-100"
              : "border-slate-100 bg-white text-slate-800"
          }`}
        >
          <span className={`inline-flex items-center justify-center w-9 h-9 rounded-lg ${
            tone === "dark" ? "bg-brand-blue/20 text-brand-blue" : "bg-blue-50 text-brand-blue"
          }`}>
            <Icon className="w-4 h-4" />
          </span>
          <span className="text-sm font-semibold leading-tight">{label}</span>
        </div>
      ))}
    </div>
  );
}
